import type {
  GetNotificationTabListResponse,
  GetNotificationsResponse,
  GetNotificationsSearchParams,
} from '@/types/notification'
import type { Options } from 'ky'
import { INITIAL_PER_PAGE } from '@/utils/constant'
import { httpClient } from '@/utils/http'

export const notificationService = {
  tabList: (options?: Options) =>
    httpClient
      .get('notifications/tab_lists', options)
      .json<GetNotificationTabListResponse>(),
  notifications: (params: GetNotificationsSearchParams, options?: Options) =>
    httpClient
      .get('notifications', {
        searchParams: {
          ...params,
          page: params.page ?? 1,
          per_page: INITIAL_PER_PAGE,
        },
        ...options,
      })
      .json<GetNotificationsResponse>(),
  notification: (id: string, options?: Options) =>
    httpClient
      .get(`notifications/${id}`, {
        ...options,
      })
      .json<GetNotificationsResponse>(),
  read: (id: string) => httpClient.post(`notifications/${id}/read`).json(),
}
